module.exports = __webpack_public_path__ + "./fonts/logo.f1ede83647654a02f9dc3d2568b906d8.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/logo.svg
// module id = ./public/img/logo.svg
// module chunks = 0